<template>
  <div class="wpdonation-box">
    <h2 class="wpdonation-title" v-if="strings">{{ strings.title }}</h2>

    <div class="easy-donation-box">
      <div class="single-credit-cardd">
        <div class="wpcm-row wpmc-justify-content-center">
          <div class="wpcm-col-md-6">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('first_name')"
                :value="billing_fields.first_name"
                @input="setBillingValue('first_name', $event.target.value)"
                :disabled="loading"
                required
              />
            </div>
          </div>
          <div class="wpcm-col-md-6">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('last_name')"
                :value="billing_fields.last_name"
                @input="setBillingValue('last_name', $event.target.value)"
                :disabled="loading"
                required
              />
            </div>
          </div>
          <div class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="email"
                :placeholder="trans('email')"
                :value="billing_fields.email"
                :readonly="is_logged_in && email"
                :disabled="loading"
                @input="setBillingValue('email', $event.target.value)"
                required
              />
            </div>
          </div>
          <div class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('address')"
                @input="setBillingValue('address', $event.target.value)"
                :disabled="loading"
                :value="billing_fields.address"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <slot></slot>
  </div>
</template>

<script>
const { mapState, mapMutations } = window.Vuex;
export default {
  props: ["is_logged_in", "email", "strings"],
  computed: {
    ...mapState(["billing_fields", "loading"]),
  },
  watch: {
    email(val) {
      if (this.is_logged_in && val) {
        this.setBillingValue("email", val);
      }
    },
  },
  mounted() {
    if (this.is_logged_in && this.email) {
      this.setBillingValue("email", this.email);
    }
  },
  methods: {
    setValue(key, val) {
      this.$store.commit("setValue", { key, val });
    },
    setBillingValue(key, val) {
      this.$store.commit("setBillingValue", { key, val });
    },
    trans(key) {
      if (this.strings) {
        return this.strings[key];
      }
    },
  },
};
</script>